<template>
  <div class="menu">
    <template v-for="(item,index) in menu">
      <router-link
        v-if="item.show"
        :key="index"
        class="nav"
        tag="div"
        replace
        active-class="nav_active"
        :to="item.to"
      >
        {{ item.text }}
      </router-link>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    menu: {
      type: Array,
      require: true,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    }
  }
}
</script>
<style scoped lang="scss">
.menu {
  background: #f8e2e2;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
  height: 100%;
  .nav {
    height: 60px;
    border-bottom: 2px transparent solid;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 60px;
    text-align: center;
    color: #ca8f92;
    width: 100%;
    cursor: pointer;
    transition: all 0.3 ease-in-out;
    &:hover {
      color: #f84148;
    }
  }
  .nav_active {
    /*font-size: 24px !important;*/
    font-family: PingFang SC;
    color: #f84148;
    border-bottom: 2px #f84148 solid;
  }
}
</style>